import React from 'react';
import { Link } from 'react-router-dom';
import './PaymentCancel.css';

const PaymentCancel = () => {
    return (
        <div className="payment-cancel-container">
            <div className="payment-cancel-card">
                {/* Animated X Icon */}
                <div className="cancel-icon">
                    <div className="x-mark">
                        <svg
                            width="80"
                            height="80"
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="40"
                                cy="40"
                                r="35"
                                fill="#EF4444"
                                stroke="#DC2626"
                                strokeWidth="2"
                                className="x-circle"
                            />
                            <path
                                d="M30 30L50 50M50 30L30 50"
                                stroke="white"
                                strokeWidth="4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="x-path"
                            />
                        </svg>
                    </div>
                </div>

                {/* Cancel Content */}
                <div className="cancel-content">
                    <h1 className="cancel-title">Payment Failed / Cancelled</h1>
                    <p className="cancel-subtitle">
                        Your payment was not completed. Please try again.
                    </p>
                </div>

                {/* Action Button */}
                <div className="cancel-actions">
                    <Link to="/checkout" className="retry-btn">
                        <span>Retry Payment</span>
                    </Link>
                </div>

                {/* Decorative Elements */}
                <div className="cancel-particles">
                    <div className="particle particle-1">❌</div>
                    <div className="particle particle-2">⚠️</div>
                    <div className="particle particle-3">🚫</div>
                </div>

                {/* Additional help text */}
                <div className="help-text">
                    <p className="help-message">
                        Need help? Contact our support team for assistance.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PaymentCancel;
